import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import LoginViaGoogleMutation from './LoginViaGoogleMutation';

const LoginViaGoogleConnectorApollo = ({ children }) => {
  const [mutate, { loading }] = useMutation(LoginViaGoogleMutation);

  const createLogin = async (token) => {
    const response = await mutate({
      variables: {
        token,
      },
    });

    return response;
  };

  return children({
    loginViaGoogle: createLogin,
    loading,
  });
};

LoginViaGoogleConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default LoginViaGoogleConnectorApollo;
